import { get } from '@ember/object';
import { isEmpty } from '@ember/utils';
import {
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';

export default {
  contactId(key, newValue, oldValue, changes /*, content*/) {
    if (get(changes, 'for') === 'contact') {
      if (isEmpty(newValue)) {
        return "Contact can't be blank";
      }
    }
    return true;
  },
  group(key, newValue, oldValue, changes /*, content*/) {
    if (get(changes, 'for') === 'group') {
      if (isEmpty(newValue)) {
        return "Group can't be blank";
      }
    }
    return true;
  },
  completedAt: validatePresence({ presence: true, message: "Can't be blank" }),
  summary: validateLength({
    allowBlank: true,
    max: 1024,
    message: "Can't be longer than 1,024 characters",
  }),
};
